export function padNum(n) {
  const s = String(n);
  return s.length >= 4 ? s : s.padStart(4, "0");
}


export function money(amount, currency = "₡") {
  const n = Math.round(Number(amount) || 0);
  return currency + n.toLocaleString("es-CR");
}

export function statusLabel(status) {
  const map = {
    draft: "Borrador",
    active: "Activa",
    closed: "Cerrada",
    drawn: "Sorteada",
    cancelled: "Cancelada",
    archived: "Archivada",
    pending: "Pendiente",
    reserved: "Reservado",
    approved: "Aprobado",
    rejected: "Rechazado",
    expired: "Expirado",
  };
  return map[status] || status;
}

export function statusColor(status) {
  const map = {
    draft: "bg-neutral-100 text-neutral-600",
    active: "bg-[#E6F7FE] text-[#0092CC]",
    closed: "bg-amber-100 text-amber-700",
    drawn: "bg-indigo-100 text-indigo-700",
    cancelled: "bg-red-100 text-red-700",
    archived: "bg-neutral-200 text-neutral-600",
    pending: "bg-amber-100 text-amber-700",
    reserved: "bg-sky-100 text-sky-700",
    approved: "bg-green-100 text-green-700",
    rejected: "bg-red-100 text-red-700",
    expired: "bg-neutral-100 text-neutral-500",
  };
  return map[status] || "bg-neutral-100 text-neutral-600";
}
